import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import GoogleIcon from './icons/GoogleIcon';

const useStyles = makeStyles((theme) => ({
  googleButtonRoot: {
    height: theme.typography.pxToRem(50),
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    '& .MuiButton-startIcon': {
      marginRight: '-4px',
    },
  },
}));

interface Props {
  submitting?: boolean;
  children: React.ReactNode;
  [key: string]: any;
}

const GoogleButton: React.FC<Props> = ({ submitting, children, ...props }: Props) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.googleButtonRoot}
      variant="outlined"
      startIcon={<GoogleIcon />}
      fullWidth
      endIcon={submitting ? <CircularProgress size={28} thickness={4} /> : ''}
      {...props}
    >
      {children}
    </Button>
  );
};

export default GoogleButton;
